var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageOdakli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image-Odakli") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-774.000000, -2344.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(774.000000, 2344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.22222222 18.8888889 1.11111111 18.8888889 1.11111111 13.7777778 0 13.7777778 0 20 6.22222222 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 13.7777778 18.8888889 13.7777778 18.8888889 18.8888889 13.7777778 18.8888889 13.7777778 20 20 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 0 13.7777778 0 13.7777778 1.11111111 18.8888889 1.11111111 18.8888889 6.22222222 20 6.22222222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.11111111 1.11111111 6.22222222 1.11111111 6.22222222 0 0 0 0 6.22222222 1.11111111 6.22222222"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,10.1111111 C17.3333333,6.13458995 14.0876323,2.88888889 10.1111111,2.88888889 C6.13458995,2.88888889 2.88888889,6.13458995 2.88888889,10.1111111 C2.88888889,14.0876323 6.13458995,17.3333333 10.1111111,17.3333333 C14.0876323,17.3333333 17.3333333,14.0876323 17.3333333,10.1111111 Z M6.69345238,8.47751323 C6.69345238,7.87566138 7.18783069,7.40277778 7.76818783,7.40277778 C8.37003968,7.40277778 8.84292328,7.89715608 8.84292328,8.47751323 C8.84292328,9.07936508 8.34854497,9.55224868 7.76818783,9.55224868 C7.16633598,9.57374339 6.69345238,9.07936508 6.69345238,8.47751323 Z M12.8194444,12.6259921 C12.776455,12.6689815 11.8306878,13.8296958 10.1326058,13.8296958 C8.4130291,13.8296958 7.4672619,12.6904762 7.42427249,12.6259921 C7.16633598,12.3250661 7.23082011,11.8736772 7.53174603,11.6157407 C7.83267196,11.3578042 8.28406085,11.4222884 8.54199735,11.7232143 C8.56349206,11.744709 9.1223545,12.3895503 10.1326058,12.3895503 C11.1428571,12.3895503 11.7017196,11.744709 11.7232143,11.7232143 C11.9811508,11.4222884 12.4325397,11.3792989 12.7334656,11.6372354 C13.0128968,11.8736772 13.0558862,12.3250661 12.8194444,12.6259921 Z M12.4540344,9.57374339 C11.8521825,9.57374339 11.3792989,9.07936508 11.3792989,8.49900794 C11.3792989,7.89715608 11.8736772,7.42427249 12.4540344,7.42427249 C13.0558862,7.42427249 13.5287698,7.91865079 13.5287698,8.49900794 C13.5287698,9.07936508 13.0558862,9.57374339 12.4540344,9.57374339 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOdakli);
export default __webpack_public_path__ + "static/media/Image-Odakli.935ba366a5e12db644fc93f40356ef6c.svg";
export { ForwardRef as ReactComponent };